import { Link } from 'react-router-dom'
import { useCollection } from '../../hooks/useFirestore'
import './AdminEditor.css'

const SHIP_TYPE_LABELS = {
  galleon: 'Galleon',
  caravel: 'Caravel',
  sloop: 'Sloop',
  brigantine: 'Brigantine',
  schooner: 'Schooner',
  frigate: 'Frigate',
  longship: 'Longship',
  warship: 'Warship',
  merchant: 'Merchant',
  fishing: 'Fishing Boat',
  other: 'Other'
}

const PLACEHOLDER_SHIP = 'data:image/svg+xml,' + encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <rect fill="#1E1A22" width="100" height="100"/>
    <path d="M20 60 L50 45 L80 60 L75 70 L25 70 Z" fill="#6E2EBF"/>
    <rect x="48" y="30" width="4" height="20" fill="#6E2EBF"/>
    <path d="M52 30 L52 45 L70 40 Z" fill="#8B5CF6"/>
  </svg>
`)

export default function ShipList() {
  const { data: ships, loading } = useCollection('ships', { orderByField: 'sortOrder' })

  if (loading) {
    return (
      <div className="container">
        <div className="loading-spinner" />
      </div>
    )
  }

  return (
    <div className="container">
      <div className="editor-header">
        <h1>Ships</h1>
        <Link to="/admin/ships/new" className="btn btn-primary">
          + New Ship
        </Link>
      </div>

      {ships.length === 0 ? (
        <div className="empty-state">
          <p>No ships yet.</p>
          <p className="text-secondary">Add vessels from your campaign.</p>
        </div>
      ) : (
        <div className="admin-list">
          {ships.map(ship => {
            const isHidden = ship.hidden === true
            return (
              <Link
                key={ship.id}
                to={`/admin/ships/${ship.id}`}
                className={`admin-list-item ${isHidden ? 'hidden-item' : ''}`}
                style={{ opacity: isHidden ? 0.5 : 1 }}
              >
                <div className="item-image">
                  <img
                    src={ship.imageUrl || PLACEHOLDER_SHIP}
                    alt={ship.name}
                    onError={(e) => { e.target.src = PLACEHOLDER_SHIP }}
                  />
                </div>
                <div className="item-info">
                  <h3>
                    {ship.name}
                    {isHidden && <span className="hidden-tag">Hidden</span>}
                  </h3>
                  <p className="text-secondary">
                    {SHIP_TYPE_LABELS[ship.type] || ship.type}
                    {ship.crew?.length > 0 && ` • ${ship.crew.length} crew`}
                  </p>
                </div>
                <span className="item-badge badge-npc">
                  {SHIP_TYPE_LABELS[ship.type] || 'Ship'}
                </span>
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
